import moment from "moment";
import React, { Fragment } from "react";

const UserModal = (props) => {
  return (
    <Fragment>
      <tbody>
        <tr className="super_admin_all_users_table_body">
          <td colSpan="7" className="p-0 w-100">
            <table className="w-100 HideShowTable">
              <tbody>
                <tr className="cursor">
                  <td style={{ width: "25%" }}>
                    <div className="f15-500 mb-1">{`${props?.user?.user_id?.first_name} ${props?.user?.user_id?.last_name || ""
                      }`}</div>
                    <div className="f13-400 text-break">{props?.user?.user_id?._id}</div>
                  </td>
                  <td style={{ width: "25%" }}>
                    <div className="f15-500 mb-1">{`${props?.user?.user_id?.email || ""}`}</div>
                    <div className="f13-400 text-break">#{props?.user?.user_id?.mobile_number}</div>
                  </td>
                  <td style={{ width: "25%" }}>
                    <div className="f15-500">
                      <div className="f15-500 mb-1">
                        {props?.user?.deleteDate ? moment(props?.user?.deleteDate).format("Do MMMM YYYY") : '-'}
                      </div>
                      <div className="f15-500 mb-1">
                        {props?.user?.deleteDate ? moment(props?.user?.deleteDate).format("hh:mm A") : "-"}
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "25%" }}>
                    <div className="f15-500">
                      {props?.user?.reason || "-"}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </Fragment>
  );
};

export default UserModal
